var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureFileEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160856",
    "data-name": "Group 160856",
    transform: "translate(-1152 -486)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_493",
    "data-name": "Rectangle 493",
    width: 18,
    height: 18,
    transform: "translate(1152 486)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160855",
    "data-name": "Group 160855"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M20.163-.2a1.763,1.763,0,0,1,2.494,2.494L11.325,12.786,8,13.618l.831-3.325Z",
    transform: "translate(1145.624 489.003)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M12.353,20h8",
    transform: "translate(1148.858 482.62)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureFileEditIcon);
export default __webpack_public_path__ + "static/media/secure-file-edit-icon.62e9a3df9fd68045dfd701e16c2f9440.svg";
export { ForwardRef as ReactComponent };